import React, {useEffect, useState, useRef} from 'react'
import { useParams } from 'react-router-dom';
import Sidebar from '../Sidebar';
// import env from 'react-dotenv'

export default function KCASpotRateForm() {
    //all the states
    const [date, setDate] = useState('')
    const [dateformat, setDateFormat] = useState('')
    const [exGinningPrices, setExGinningPrices] = useState()
    const [exSpotRatesKarachi, setExSpotRatesKarachi] = useState(235)
    const [clbs, setClbs] = useState()
    const [rateAvl, setRateAvl] = useState(false)
    const [dollarRate, setDollarRate] = useState()
    const [x, setX] = useState('')

    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        setDate(today);
        gerrit()
      }, []);

    //ex-ginning prices value
    const handlerEGP = (e) =>{
        setExGinningPrices(e.target.value)
    }
    useEffect(()=>{
       // console.log(exGinningPrices)
        setExSpotRatesKarachi(parseFloat(235) + parseFloat(exGinningPrices))
    },[exGinningPrices])

    //ex-spot rates karachi
    const handlerESRK = (e) =>{
        setExSpotRatesKarachi(e.target.value)
    }
    useEffect(()=>{
       // console.log(exSpotRatesKarachi)
        const w = exSpotRatesKarachi
        setClbs(w/x)
    },[exSpotRatesKarachi])

    //clbs
    const handleClbs = (e) =>{
        setClbs(e.target.value)
    }
    useEffect(()=>{
       // console.log(clbs)
    },[clbs])

    //Date effect
    useEffect(()=>{
       // console.log(date)
    },[date])

    //fetching the USD rate
  const gerrit =async ()=>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/usd-rate`,{
      headers: {
        'x-access-token': token
      }
    })
    if(!response.ok){
      setRateAvl(false)
    }
    else{
      const data = await response.json()
      setDollarRate(data.buying)
    }
  }

  //date formatting fixture
    function formatDateToYYYYMMDD(inputDate) {
    const dateObject = new Date(inputDate);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
    const day = String(dateObject.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
    }

    const {_id} = useParams()
    const token = sessionStorage.getItem('token')
    const gerrit2 = async () =>{
      const response = await fetch(`${process.env.REACT_APP_API_URL}/getKCAs/${_id}`,{
        headers: {
          'x-access-token': token
        }
      })
      const data = await response.json()
      setDate(data.date)
      setClbs(data.clbs)
      setExGinningPrices(data.exGinningPrices)
      setExSpotRatesKarachi(data.exSpotRatesKarachi)
      setDateFormat(formatDateToYYYYMMDD(data.date))
     // console.log(data)
    }

    useEffect(()=>{
        gerrit2()
    },[])

  //setting x which will be divided by the EKSR
  useEffect(()=>{
    setX((dollarRate*82.28456)/100)
   // console.log("This is the dollar rate", dollarRate)
  }, [dollarRate])

  //console
  useEffect(()=>{
   // console.log("This is the clbs", clbs)
  },[clbs])

  const handleSubmit =  async (e) =>{
    e.preventDefault()
    const token = sessionStorage.getItem('token')
    const items = {date:date, exGinningPrices:exGinningPrices, exSpotRatesKarachi:exSpotRatesKarachi, clbs:clbs}
    const response = await fetch(`${process.env.REACT_APP_API_URL}/updateKca/${_id}`,{
        method:"PUT",
        headers:{
            "Content-Type":"application/json",
            'x-access-token':token
        },
        body:JSON.stringify(items)
    })
        // .then(console.log(items))
  }
  return (
    <>
    <div className="sidebar">
    <Sidebar/>
  </div>
    <div id='bydrop'>
      <form onSubmit={handleSubmit}>
              {/* <div class="input-group input-group-md mb-3">
              <div className="mb-3">
        <label htmlFor="date" className="form-label">
          Date
        </label>
        <input
          id="num-value"
          type="date"
          className="form-control"
          min="0"
          required
          value={date || ""}
          onChange={(e) => {
            setDate(e.target.value)
           // console.log("Date changed")
          }}
        />
      </div></div> */}

<div className="col-md-6">
            {/**Date */}
            <label htmlFor="num-value" className="form-label">Date</label>
            <div className="input-group input-group-md mb-3">
                <input type="date" id="num-value" value={dateformat} className="form-control" aria-label="Small"   onChange={(e) => {
                  setDate(e.target.value)
                  setDateFormat(formatDateToYYYYMMDD(e.target.value))
                }} aria-describedby="inputGroup-sizing-sm" />
            </div>
        </div>


              <label for="exampleFormControlTextarea1" class="form-label">Ex-ginning</label>
              <div class="input-group input-group-md mb-3">
              <input class="form-control" type="number" value={exGinningPrices}  onChange={handlerEGP} required  />              </div>
    
              <label for="exampleFormControlTextarea1" class="form-label" >Ex-Spot Rates Karachi</label>
              <div class="input-group input-group-md mb-3">
              <input class="form-control" value={exSpotRatesKarachi} type="number" readOnly placeholder="Readonly input here…" onChange={handlerESRK}/>              </div>
              

              <label for="exampleFormControlTextarea1" class="form-label" >Clbs</label>
              <div class="input-group input-group-md mb-3">
              <input class="form-control" type="number" value={clbs} readOnly placeholder="Readonly input here…" onChange={handleClbs} readonly/>              </div>
              <button type="submit" id ="button-submit"className=" btn btn-secondary btn-lg">Submit</button>
      </form>
    </div>
    </>
  )
}
 